import { createIcon } from '@chakra-ui/icons';

export const UserGroup = createIcon({
  displayName: 'UserGroup',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3390_2042)">
        <path
          d="M5.24935 7.58318C6.53793 7.58318 7.58268 6.53843 7.58268 5.24985V4.08318C7.58268 2.7946 6.53793 1.74985 5.24935 1.74985C3.96077 1.74985 2.91602 2.7946 2.91602 4.08318V5.24985C2.91602 6.53843 3.96077 7.58318 5.24935 7.58318Z"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M4.10394 7.28098L1.16685 8.74981L0.747436 12.1051C0.660519 12.8016 1.2036 13.4165 1.90535 13.4165H5.25019H8.59502C9.29677 13.4165 9.83985 12.8016 9.75294 12.1051L9.33352 8.74981L6.39644 7.28098"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
        />
        <path
          d="M11.6671 9.91636H12.0399C12.7609 9.91636 13.3092 9.26886 13.1908 8.55778L12.8338 6.41636L10.123 5.06128L10.5005 5.2497"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M8.29297 0.925608C8.58347 0.710358 8.94339 0.583191 9.33305 0.583191C10.2996 0.583191 11.0831 1.36661 11.0831 2.33319V3.49986C11.0831 4.39702 10.4081 5.13611 9.53839 5.23819"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_3390_2042">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
